import officeApiWrapper from '@/taskpane/common/office-api-wrapper'
import office from '@/taskpane/officejs/office-wrapper'
import state from '@/taskpane/state/sidebar-state'
import sendMessageToSidebar from '../messages/send-message-to-sidebar'
import MessageArgs, { defaultMessageArgs } from '../messages/message-args'

interface GraphAccessAlertArgs extends MessageArgs {
  connected: boolean
  message: string
}

export default async function establishGraphAccessHandler() {
  state.testingGraphAccess = true
  const accessArgs: GraphAccessAlertArgs = defaultMessageArgs() as GraphAccessAlertArgs

  try {
    const id = (await office.id()) || (await office.save())

    if (office.mode.isMessage() && !office.mode.isInvitation()) {
      await officeApiWrapper.getMailInfo(id)
    } else {
      await officeApiWrapper.getEventInfo(id)
    }

    state.currentItem.apiInfo.isGraphApiAvailable = true
    accessArgs.connected = true
  } catch (error) {
    accessArgs.connected = false
    accessArgs.message = error
  }

  sendMessageToSidebar('GraphAccessAlert', accessArgs)
}
